import { c as _c } from "react/compiler-runtime";
import LinkButton from '../link-button';
import type { CtaProps } from './cta.types';

// `LinkButton` is `w-fit`, so it needs centring the column's stretch default won't give it.
export const CtaLink = t0 => {
  const $ = _c(14);
  const {
    cta
  } = t0;
  if (cta.type === "link") {
    let t1;
    if ($[0] !== cta.actionName || $[1] !== cta.disabled || $[2] !== cta.href || $[3] !== cta.onClick || $[4] !== cta.target || $[5] !== cta.text) {
      t1 = <LinkButton href={cta.href} target={cta.target} onClick={cta.onClick} disabled={cta.disabled} data-dd-action-name={cta.actionName} className="self-center">{cta.text}</LinkButton>;
      $[0] = cta.actionName;
      $[1] = cta.disabled;
      $[2] = cta.href;
      $[3] = cta.onClick;
      $[4] = cta.target;
      $[5] = cta.text;
      $[6] = t1;
    } else {
      t1 = $[6];
    }
    return t1;
  }
  const t1 = cta.type === "submit" ? cta.form : undefined;
  let t2;
  if ($[7] !== cta.actionName || $[8] !== cta.disabled || $[9] !== cta.onClick || $[10] !== cta.text || $[11] !== cta.type || $[12] !== t1) {
    t2 = <LinkButton type={cta.type} onClick={cta.onClick} disabled={cta.disabled} data-dd-action-name={cta.actionName} form={t1} className="self-center">{cta.text}</LinkButton>;
    $[7] = cta.actionName;
    $[8] = cta.disabled;
    $[9] = cta.onClick;
    $[10] = cta.text;
    $[11] = cta.type;
    $[12] = t1;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  return t2;
};